export class CustomError extends Error {
    triggerRefresh: boolean;
    messages?: string[];

    constructor(message: string, { failArray, triggerRefresh }: { failArray: any, triggerRefresh: boolean }) {
        super(message);
        this.triggerRefresh = triggerRefresh;
        this.getErrorMessages(failArray);
    }

    getErrorMessages(arr: any) {
        let errorMessages = [];
        for (let i = 0; i < arr.length; i++) {
            errorMessages.push(arr[i].errorMessage);
        }
        this.messages = errorMessages;
    }
}